// extracted by mini-css-extract-plugin
export default {"container":"MbTBe8Qb","widget":"JEOyTpLP"};